const _ = require('lodash');
const location = require('swa-location/location');
const navigator = require('swa-app-core/navigator');
const urls = require('swa-bootstrap-data/urls');

module.exports = _.assign({}, navigator, {

    navigateToAirBooking (queryParams) {
        location.setLocationHref(urls.AIR_BOOKING_SELECT_DEPART + queryParams);
    },

    navigateToAirCancelReservation (queryParams) {
        location.setLocationHref(urls.AIR_CANCEL_VIEW + queryParams);
    },

    navigateToAirChange (queryParams) {
        location.setLocationHref(urls.AIR_CHANGE_VIEW + queryParams);
    },

    navigateToAirCheckIn (queryParams) {
        location.setLocationHref(urls.AIR_CHECK_IN_REVIEW + queryParams);
    },

    navigateToCarBooking (queryParams) {
        location.setLocationHref(urls.CAR_BOOKING_SELECT_PAGE + queryParams);
    },

    navigateToFlightStatus (queryParams) {
        location.openBrowserWindow(urls.AIR_FLIGHT_STATUS_RESULTS_PAGE + queryParams);
    },

    navigateToIndexPage (queryParams) {
        this.push({ state: null, pathname: this.getApplicationPagePath('index.html'), query: queryParams });
    },

    navigateToLoginPage (queryParams) {
        this.push({ state: null, pathname: this.getApplicationPagePath('login.html'), query: queryParams });
    },

    navigateToVacation (queryParams) {
        location.setLocationHref(urls.VACATION_PAGE + queryParams);
    },

    replaceWithIndexPage (queryParams) {
        this.replace({ state: null, pathname: this.getApplicationPagePath('index.html'), query: queryParams });
    },

    replaceWithLoginPage (queryParams) {
        this.replace({ state: null, pathname: this.getApplicationPagePath('login.html'), query: queryParams });
    }
});
